<ion-app>
  <ion-split-pane contentId="main">
    <ion-menu side="start" contentId="main">
      <ion-header>
        <!-- <ion-toolbar color="primary">
          <ion-title>Menu</ion-title>
        </ion-toolbar> -->
        <!-- <app-aff-utilisateur></app-aff-utilisateur> -->
        <app-user-display *ngIf="isLogged"></app-user-display>
      </ion-header>
      <ion-content>
        <!-- <ion-item color="tertiary" lines="none"> </ion-item> -->
        <!-- <ion-item color="tertiary" lines="none">
          <ion-avatar>
            <img src="https://gravatar.com/avatar/dba6bae8c566f9d4041fb9cd9ada7741?d=identicon&f=y">
          </ion-avatar>
          &nbsp;&nbsp;
          <ion-label class="ion-text-end"><strong>apalermo@u-link.fr</strong></ion-label>
        </ion-item>
        <ion-item color="tertiary">
        </ion-item> -->
        <ion-list>
          <ng-container *ngIf="appPages.length">
            <ion-item button routerLink="site/" replaceUrl="true" lines="full">
              <ion-icon slot="start" src="assets/Accueil-OFF.svg"></ion-icon>
              <ion-label>
                {{ "MENU.HOME" | translate }}
              </ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-label>
                <h2>
                  {{ "MENU.SITEHEADER" | translate }} -
                  {{ site.properties.name }}
                </h2>
              </ion-label>
            </ion-item>
          </ng-container>
          <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
            <ion-item [routerDirection]="'root'" [routerLink]="[p.url]" [lines]="p.lines">
              <ion-icon slot="start" [src]="p.icon" size="large"></ion-icon>
              <ion-label>
                {{ p.title | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item button routerLink="/task" lines="full">
            <ion-icon slot="start" name="clipboard"></ion-icon>
            <ion-label>
              Tâches
            </ion-label>
          </ion-item>
          <ion-item button (click)="logout()" lines="full">
            <ion-icon slot="start" name="power"></ion-icon>
            <ion-label>
              {{ "MENU.LOGOUT" | translate }}
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
      <!-- <ion-footer>
        <ion-toolbar color="primary">          
          <ion-item color="primary" slot="end">
            <ion-button (click)="logout()" shape="round" size="small">
              <ion-icon slot="icon-only" name="power"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-toolbar>
      </ion-footer> -->
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane> 
  
      <ion-modal class="auto-height" id="privacyModal" mode="ios" [canDismiss]="canDismiss">
        <ng-template>
          <ion-header>
            <ion-toolbar color="white" lines="none">
              <ion-title>Politique de confidentialité</ion-title>             
            </ion-toolbar>
          </ion-header>
          <div class="inner-content">
           <ion-grid class="white-bg">
            <p class="ion-padding-horizontal" style="font-family:Lato-Regular">La protection de vos donnéees personnelles est primordiale pour nous. Veuillez lire et accepter les conditions d'utilisation de SoluPass.</p>
            <ion-item>
              <ion-label class="ion-text-wrap" for="terms">J'ai lu et j'accepte la <a href="https://www.u-link.fr/privacy-policy/">politique de confidentialité</a></ion-label>
              <ion-checkbox id="terms" (ionChange)="onTermsChanged($event)" [checked]="canDismiss"></ion-checkbox>
            </ion-item>
          </ion-grid>
        </div>
          <ion-footer>
            <ion-row class="ion-text-center">
              <ion-col>
              <ion-button [disabled]="!canDismiss" (click)="privacyModal.dismiss()">Valider</ion-button>
              </ion-col>
            </ion-row>
          </ion-footer>
        </ng-template>
      </ion-modal>
      
  <!-- <app-right-menu></app-right-menu> -->
</ion-app>